/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { FormConfig } from './form-config';

export const defaultFormConfig: FormConfig = {
  form: {
    passwordVisibilityToggle: true,
  },
};
